const inkeep_ai_bot = {
    intro_message: 'Ciao, sono Logto AI!\n\nSono un assistente AI addestrato su documentazione, articoli di aiuto e altri contenuti.\n\nChiedimi qualsiasi cosa su `Logto`.',
    chat_placeholder: 'Chiedi a Logto AI la tua domanda per una guida passo-passo',
    disclaimer_label: 'Disclaimer di Logto AI',
    disclaimer_tooltip: "Le risposte sono generate dall'AI e potrebbero richiedere verifica.",
    example_questions_label: 'Domande di esempio',
    example_questions: [
        'Guida rapida per la configurazione di Logto',
        "Configura l'architettura multi-tenancy",
        'Come integrare il profilo utente?',
    ],
    stop: 'Ferma',
    clear: 'Ricominciamo',
    get_help: 'Ottieni aiuto',
    copy_chat: 'Copia',
    ask_ai_label: "Chiedi all'AI",
    contact: 'Contatto',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
